import React from "react";
import styled from "styled-components";

const Root = styled.div`
  font-size: 0;

  svg {
    height: 28px;
  }
`;

interface IProps {
  svg: string;
}

const KomonNavigationNavbarLogo = ({ svg }: IProps) => (
  <Root dangerouslySetInnerHTML={{ __html: svg }} />
);

export default KomonNavigationNavbarLogo;
